import { Injectable, Provider } from "@angular/core";
import { Observable } from "rxjs";
import { CalendarClient, CalendarGetQuery, CalendarGetQueryResult } from "../../INTEGRA_Shop_Client";
import { ICalendarApiService, ICalendarApiServiceToken } from "./calendar-api-service.interface";

@Injectable({
  providedIn: 'root'
})
export class CalendarApiService implements ICalendarApiService {

  constructor(
    private calendarClient: CalendarClient,
  ) { }

  public calendarGet(query: CalendarGetQuery): Observable<CalendarGetQueryResult> {
    return this.calendarClient.calendarGet(query);
  }

}

/**
 * Prepared provider with the token to implementation mapping.
 * Reference this at the desired provider list to enable the injection of this implementation by referencing the token(interface).
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const CalendarApiServiceProvider: Provider[] = [
  { provide: CalendarClient },
  { provide: ICalendarApiServiceToken, useExisting: CalendarApiService }
];
